import * as Sentry from '@sentry/react'
import { ModalMountTarget } from 'bold-ui'
import { AlertContainer } from 'components/AlertContainer'
import { BarraBrasil } from 'components/layout/BarraBrasil'
import { SiteWrapper } from 'components/layout/SiteWrapper'
import { setAppInstanceId } from 'config/appInstance'
import { getSentryConfig } from 'config/sentry'
import { useConfiguracoes } from 'hooks/configuracoes'
import { useEffect } from 'react'
import { v4 as uuidV4 } from 'uuid'

import { AlertStickyContainer } from './AlertStickyContainer'
import { AuthPortal } from './auth/AuthPortal'
import { ErrorView } from './error/ErrorView'
import { InstalacaoRootView } from './instalacao/InstalacaoRootView'

export function InitialView() {
  const {
    configuracoes: { ativado, sentry },
  } = useConfiguracoes()

  useEffect(() => {
    if (sentry.enabled) {
      const client = Sentry.init(getSentryConfig(sentry.dsn))
      Sentry.setTag('origin', 'frontend')

      return () => {
        client.close()
      }
    }
  }, [sentry.dsn, sentry.enabled])

  setAppInstanceId(uuidV4())

  return (
    <Sentry.ErrorBoundary fallback={ErrorView}>
      <SiteWrapper>
        <BarraBrasil />

        <AlertStickyContainer>
          <AlertContainer />
        </AlertStickyContainer>

        {!ativado ? <InstalacaoRootView /> : <AuthPortal />}

        <ModalMountTarget />
      </SiteWrapper>
    </Sentry.ErrorBoundary>
  )
}
